import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useRef, useEffect } from "react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./landingPageNew.css";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

export default function LandingPageNew() {

  const apple = useRef(null);
  const we = useRef(null);
  const one = useRef(null);
  const two = useRef(null);
  const three = useRef(null);
  const four = useRef(null);
  const description1 = useRef(null);
  const description2 = useRef(null);
  const description3 = useRef(null);

  const isDesktop = window.matchMedia("(min-width: 768px)").matches;

  useGSAP(() => {

    const pTags = one.current.querySelectorAll("p"); // Select all <p> tags within the div
    const nexGenLetters = pTags[0].querySelectorAll("span");

    gsap.from(one.current, {
      opacity: 0,
      stagger: 0.1,
      delay: 0.1,
      duration: 10,
      ease: "elastic.out",
    });

    gsap.to(nexGenLetters, {
      // color: "#ffff00", // Change to yellow
      color: "red", // Change to purple
      stagger: 0.1, // Delay between each letter
      duration: 1.6,
      ease: "power1.inOut",
      delay: 1, // Starts after the initial animation completes
    });
  });

  useGSAP(() => {
    if (isDesktop) {
      gsap.from(apple.current, {
        opacity: 0,
        stagger: 0.1,
        delay: 1.2,
        duration: 10,
        ease: "elastic.out",
      });
    }
  });

  useGSAP(() => {
    if (isDesktop) {
      gsap.from(we.current, {
        opacity: 0,
        stagger: 0.1,
        delay: 1.2,
        duration: 10,
        ease: "elastic.out",
      });
    }
  });

  useGSAP(() => {
    if (isDesktop) {
      const pTags = two.current.querySelectorAll("p"); // Select all <p> tags within the div
      gsap.from(pTags, {
        y: "100%",
        scale: 1.5,
        opacity: 0,
        stagger: 0.1,
        duration: 1.9,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: one.current, // Triggers when the <p> tag enters the viewport
          start: "center top", // Animation starts when the top of the element is at the center of the viewport
          toggleActions: "play none none none", // Only play on scroll down
        },
      });

      gsap.to(two.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: two.current,
          start: "top top", // Adjust to control when the fade-out starts
          end: "center top",
          scrub: true,
          // markers: true,
        },
      });

      gsap.from(two.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: two.current,
          start: "center bottom", // Adjust to control when the fade-out starts
          end: "center center",
          scrub: true,
          // markers: true,
        },
      });
    }

  });

  useGSAP(() => {
    if (isDesktop) {
      const pTags = three.current.querySelectorAll("p"); // Select all <p> tags within the div
      gsap.from(pTags, {
        y: "100%",
        scale: 1.5,
        opacity: 0,
        stagger: 0.1,
        duration: 1.9,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: two.current, // Triggers when the <p> tag enters the viewport
          start: "top top", // Animation starts when the top of the element is at the center of the viewport
          toggleActions: "play none none none", // Only play on scroll down
        },
      });

      gsap.to(three.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: three.current,
          start: "top top", // Adjust to control when the fade-out starts
          end: "center top",
          scrub: true,
        },
      });

      gsap.from(three.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: three.current,
          start: "center bottom", // Adjust to control when the fade-out starts
          end: "center center",
          scrub: true,
          // markers: true,
        },
      });
    }

  });

  useGSAP(() => {
    if (isDesktop) {
      const pTags = four.current.querySelectorAll("p"); // Select all <p> tags within the div
      gsap.from(pTags, {
        y: "100%",
        scale: 1.5,
        opacity: 0,
        stagger: 0.1,
        duration: 1.9,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: three.current, // Triggers when the <p> tag enters the viewport
          start: "top top", // Animation starts when the top of the element is at the center of the viewport
          toggleActions: "play none none none", // Only play on scroll down
        },
      });

      gsap.to(four.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: four.current,
          start: "top top", // Adjust to control when the fade-out starts
          end: "center top",
          scrub: true,
        },
      });

      gsap.from(four.current, {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: four.current,
          start: "center bottom", // Adjust to control when the fade-out starts
          end: "center center",
          scrub: true,
          // markers: true,
        },
      });
    }

  });

  useGSAP(() => {
    if (isDesktop) {
      gsap.from(description1.current, {
        opacity: 0,
        stagger: 0.1,
        delay: 0.8,
        duration: 10,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: description1.current, // Triggers when the <p> tag enters the viewport
          // start: "center top", // Animation starts when the top of the element is at the center of the viewport
          // toggleActions: "play none none none", // Only play on scroll down
        },
      });
    }
  });

  useGSAP(() => {
    if (isDesktop) {
      gsap.from(description2.current, {
        opacity: 0,
        stagger: 0.1,
        delay: 0.8,
        duration: 10,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: description2.current, // Triggers when the <p> tag enters the viewport
          // start: "center top", // Animation starts when the top of the element is at the center of the viewport
          // toggleActions: "play none none none", // Only play on scroll down
        },
      });
    }
  });

  useGSAP(() => {
    if (isDesktop) {
      gsap.from(description3.current, {
        opacity: 0,
        stagger: 0.1,
        delay: 0.8,
        duration: 10,
        ease: "elastic.out",
        scrollTrigger: {
          trigger: description3.current, // Triggers when the <p> tag enters the viewport
          // start: "center top", // Animation starts when the top of the element is at the center of the viewport
          // toggleActions: "play none none none", // Only play on scroll down
        },
      });
    }
  });

  const colors = ["#53bde3", "#ffb900", "#f78200", "#e23838", "#973999", "#009cdf"];
  const textRef = useRef(null); // useRef hook to reference the DOM element

  useEffect(() => {
    const text = "Powered by Apple";
    const container = textRef.current;

    if (container) {
      container.innerHTML = ""; // Clear original content

      // Loop through each letter and apply color dynamically
      for (let i = 0; i < text.length; i++) {
        let span = document.createElement("span");
        span.innerText = text[i];
        span.style.color = colors[i % colors.length]; // Cycle through the colors array
        span.style.fontSize = "21px"; // Cycle through the colors array
        container.appendChild(span);
      }
    }
  }, []); // Empty dependency array to run once when the component mounts

  return (
    <div>
      <div className="container">
        <div className="sectionOne">
          <div ref={one} className="introPageText">
            <div className="we" ref={we}>
              {/* We make custom */}
            </div>
            <p className="nexGen">
              <span>N</span>
              <span>e</span>
              <span>x</span>
              <span>t</span>
              <span> </span> {/* for the space */}
              <span>g</span>
              <span>e</span>
              <span>n</span>
            </p>
            <p>Instrument</p>
            <p>clusters</p>
            <div className="apple" ref={apple}>
              with
              <span className="apple"> </span>
              <span className="apple a">A</span>
              <span className="apple p1">p</span>
              <span className="apple p2">p</span>
              <span className="apple l">l</span>
              <span className="apple e">e</span>
              <span className="apple"> </span>
              CarPlay
            </div>
          </div>
        </div>


        <div className="section section-sub">
          <div>
            <div ref={two}>
              <p>High quality</p>
              <p>Displays</p>
            </div>
            <p className="description" ref={description1}>Experience the precision of high-quality displays,
              delivering sharp visuals and seamless performance in our custom digital instrument
              clusters. <span className="red-highlight">Designed for clarity and responsiveness, </span>
              these displays ensure an enhanced driving experience.
            </p>
          </div>
        </div>

        <div className="section section-sub">
          <div>
            <div ref={three}>
              <p>Customizable</p>
              <p>Layouts</p>
            </div>
            <p className="description" ref={description2}>We allow drivers to personalize their digital
              instrument cluster by choosing from <span className="red-highlight">various
                themes, colors, and gauge styles.</span> Tailor the display to match your
              preferences and driving needs for a more engaging and personalized driving experience.
            </p>
          </div>
        </div>


        <div className="section section-sub">
          <div>
            <div ref={four} className="last-section">
              <p>Greater</p>
              <p>Information Density</p>
            </div>
            <p className="description" ref={description3}>
              {/* We offer a wider range of information simultaneously,
              including <span className="red-highlight">navigation, performance metrics,
                and multimedia details,</span> all in a clear and organized manner.  */}
              We provide greater information density, allowing
              drivers to view multiple metrics simultaneously. Enjoy <span className="red-highlight">real-time data on
                speed, fuel efficiency, navigation, multimedia,</span> and more, all presented clearly and
              organized for easy access with OBD 2 port support.

            </p>
          </div>
        </div>

      </div>
    </div >
  );
}
